export const APP_VERSION = `V1.8.4 (${__APP_BUILD__})`;
export const APP_BUILD_DATE = new Date(parseInt(__APP_BUILD__, 36) * 1000).toUTCString();

export const CHANGELOG = [
  {
    version: 'V1.8.4',
    date: '9 mei 2026',
    changes: [
      "Productie-fix: 'Even geduld…' onderhoudsscherm verholpen — ontbrekende omgevingsvariabelen in de productiebuild zijn opgelost zodat de app weer normaal opstart.",
      "Monitoring: ontbrekende env-vars worden nu direct gerapporteerd via console én client-error-log, zodat een vergelijkbare release-incident onmiddellijk zichtbaar is voor agents.",
      "Tests: regressietest toegevoegd die vóór elke release controleert of .env aanwezig is, niet gegitignored is, en alle vereiste VITE_*-variabelen bevat.",
    ],
  },
  {
    version: 'V1.8.3',
    date: '9 mei 2026',
    changes: [
      "Synchronisatie: Vastlopend 'Synchroniseren...'-bandje opgelost — corrupte sync-effecten worden automatisch opgeschoond bij het openen van de app (max 5 pogingen of 24u).",
      "Synchronisatie: Permanente fouten (zoals rechten of validatie) worden niet meer eindeloos herhaald maar netjes geparkeerd in de dead-letter queue voor handmatige review.",
      "Boodschappen: Boodschappen verschijnen niet meer per ongeluk in de takenlijst, planning of agenda — strikte scheiding tussen taken en boodschappen.",
      "Stabiliteit: Build-fouten opgelost na schemawijziging (task_flows en device-autorisatie hersteld).",
    ],
  },
  {
    version: 'V1.8.2',
    date: '30 maart 2026',
    changes: [
      "Optimalisatie: Build-waarschuwingen voor dynamische imports opgelost voor betere prestaties.",
      "Bundel-optimalisatie: Chunking-strategie verfijnd om de initiële laadtijd te verkorten (vendor chunk verkleind van 1.8MB naar 234kB).",
      "Stabiliteit: HEIC-afbeeldingsbibliotheek wordt nu alleen geladen wanneer dat nodig is.",
    ],
  },
  {
    version: 'V1.8.1',
    date: '29 maart 2026',
    changes: [
      "Stabiliteit: Productie-build fout opgelost door het toevoegen van de ontbrekende @capacitor/app dependency.",
    ],
  },
  {
    version: 'V1.8.0',
    date: '28 maart 2026',
    changes: [
      "Webhooks: Ondersteuning voor 'silent login' via inloggegevens in de payload en directe JSON-antwoorden voor externe aanroepen.",
      "Vite: Server-side middleware toegevoegd voor slimme afhandeling van webhook-verzoeken.",
      "API: Productie-ready serverless function toegevoegd voor webhooks op Vercel.",
    ],
  },
  {
    version: 'V1.7.3',
    date: '14 maart 2026',
    changes: [
      "Algemene verbeteringen: Verschillende grootschalige verbeteringen en functionele updates.",
    ],
  },
  {
    version: 'V1.7.2',
    date: '14 maart 2026',
    changes: [
      "Synchronisatie: repository bijgewerkt naar de laatste versie op origin/main",
      "Datumbeheer: overstap naar lokale tijdformattering voor consistente weergave",
      "Sneller laden: taken worden direct getoond vanuit cache terwijl nieuwe data op de achtergrond wordt opgehaald",
      "Beveiliging: verbeterde webhook-validatie met invoerlengtebeperkingen",
      "Privacy: IP-adres tracking verwijderd voor betere GDPR-compliance",
      "Bot accounts: veiligere aanmaak via backend functie",
      "Stabiliteit: oneindige lus in profielupdates opgelost",
      "Motivatie-herinneringen: ondersteuning voor persoonlijke tijdzone en dagelijkse notificatie",
    ],
  },
  {
    version: 'V1.7.1',
    date: '21 februari 2026',
    changes: [
      "Klikbare statistieken: Bekijk voltooide taken door op de tellers van 'Vandaag' en 'Deze week' te klikken",
      "Onboarding: Verbeterde introductie voor het maken of lid worden van een (publiek) team",
      "Instellingen: Optie toegevoegd om een standaard team in te stellen bij het opstarten",
      "Leaderboard: Eerlijkere puntenverdeling met een minimum van 5 punten per taak",
      "Staatbeheer: Nieuwe 'Quick State Selector' voor snellere bediening op mobiel",
      "Slimme navigatie: Automatische redirects naar actieve modules bij het wisselen van teams",
      "Webhooks: Ondersteuning voor meerdere acties per webhook (aanmaken, bewerken, verwijderen)",
      "Vormgeving en Bugfixes: Consistente weergave van bijnamen, verbeterde taaktoewijzing en mobiele weergave",
    ],
  },
  {
    version: 'V1.7.0',
    date: '10 februari 2026',
    changes: [
      "Optimalisatie: snellere laadtijden door tekstcompressie en caching",
      "Bugfix: redirects bij inloggen en registreren opgelost",
      "Toegankelijkheid: betere ondersteuning voor schermlezers in dialogen",
      "Stabiliteit: diverse technische verbeteringen en bugfixes",
    ],
  },
  {
    version: 'V1.6.0.8',
    date: '8 februari 2026',
    changes: [
      "Process: gebruik van build-nummers voor ACC (1.6.0.x)",
      "Sync: versie in de footer is nu gekoppeld aan APP_VERSION",
    ],
  },
  {
    version: 'V1.6.0',
    date: '8 februari 2026',
    changes: [
      "Uitnodigingen: stuur gepersonaliseerde e-mails naar nieuwe teamleden",
      "Taalinstellingen: kies tussen Nederlands en Engels voor je team",
      "Edge Functions: nieuwe backend service voor betrouwbare e-mailverzending",
      "Design: prachtig opgemaakte HTML-uitnodigingen in de Clando stijl",
    ],
  },
  {
    version: 'V1.5.1',
    date: '8 februari 2026',
    changes: [
      "Process: automatische versie-synchronisatie via 'npm run version:*'",
      "Documentatie: commit-workflow toegevoegd voor AI-assistenten",
      "SemVer: duidelijk beleid voor Patch (bugs) en Minor (functies)",
    ],
  },
  {
    version: 'V1.5.0',
    date: '8 februari 2026',
    changes: [
      "Taak 'Pakken' (Grab): wijs snel taken aan jezelf toe met het hand-icoon",
      "Desktop UI: actieknoppen in een overzichtelijk 4-koloms rooster bij hover",
      "Layout stabiliteit: herstel van horizontale verschuiving in de header op laptops",
      "Staatbeheer: verbeterde popover stabiliteit bij het toewijzen van taken",
    ],
  },
  {
    version: 'V1.4.0',
    date: '1 februari 2026',
    changes: [
      "Nieuwe tag-categoriebeheer: per type icoon + subcategorieën met metadata",
      "Locatie-tags tonen vaste kleuren en iconen in taken en filters",
      "Filters vernieuwd: compacte knoppen en horizontale scroll op mobiel",
      "Kleurkiezer verbeterd met opslaan/annuleren en snelle acties",
    ],
  },
  {
    version: 'V1.3.1',
    date: '31 januari 2026',
    changes: [
      "Bugfix: snelle filter voor afgewerkte boodschappen werkt weer",
    ],
  },
  {
    version: 'V1.3.0',
    date: '31 januari 2026',
    changes: [
      "Webshop links: sla meerdere productlinks op bij voorraad en boodschappen",
      "Afbeeldingen in boodschappenlijst: zichtbare thumbnails met fullscreen viewer",
      "Automatische shopherkenning: AH, Bol.com, Amazon, etc. worden herkend",
    ],
  },
  {
    version: 'V1.2.0',
    date: '31 januari 2026',
    changes: [
      "Tijdregistratie: meet hoelang taken duren met live stopwatch",
      "Geschatte duur: admins kunnen inschatten hoelang een taak duurt",
      "Leaderboard: schakel tussen aantal taken en totale tijd",
      "Verbeterde tab navigatie: compacter design zonder zichtbare scrollbar",
    ],
  },
  {
    version: 'V1.1.1',
    date: '15 januari 2025',
    changes: [
      "Boodschappen tellen niet meer mee in het leaderboard",
    ],
  },
  {
    version: 'V1.1.0',
    date: '15 januari 2025',
    changes: [
      "Prullenbak: bekijk en herstel verwijderde taken",
      "Automatische opschoning: taken worden na 30 dagen definitief verwijderd",
      "Flows: groepeer taken in volgorde met voortgangsindicator",
      "Snooze functie voor terugkerende taken",
      "Verbeterde taak bewerking met uitgebreide opties",
      "Bugfix: soft-delete in plaats van directe verwijdering",
    ],
  },
  {
    version: 'V1.0.0',
    date: '21 december 2024',
    changes: [
      "Eerste release van de familie takenlijst app",
      "Dagelijkse, speciale en boodschappen taken",
      "Foto's toevoegen aan taken (camera & galerij)",
      "Locaties en toewijzingen",
      "Prioriteiten en deadlines",
      "TV-modus voor gezamenlijk overzicht",
      "Filters op persoon en categorie",
    ],
  },
];
